import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/firebase-auth'
import 'firebase/storage'

// firebase init
const config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_KEY_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_KEY_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
}

firebase.initializeApp(config)

// firebase db
const db = firebase.firestore()
// ignore undefined when insert to firestore
db.settings({ ignoreUndefinedProperties: true, merge: true })

// firebase auth
const firebaseAuth = firebase.auth()

const firebaseApp = firebase.app()

const firebaseStorage = firebase.storage()

const firebaseFunction = firebaseApp.functions('asia-northeast1')

// firebase collections
const usersCollection = db.collection('users')
const slugsCollection = db.collection('slugs')

export {
  firebaseAuth,
  firebaseApp,
  firebaseFunction,
  firebaseStorage,
  db,
  firebase,
  slugsCollection,
  usersCollection,
}
